/**
 * Converts an array to an object index
 * @param array Array to convert
 * @param keyName Key name to use as index
 * @returns Object with the array converted to an index object
 */
export const convertArrayToIndex = <T>(
  array: Array<any>,
  keyName: string
): {
  [key: string]: T;
} => {
  // Init
  const result: {
    [key: string]: T;
  } = {};

  // For each item
  for (const item of array) {
    // Get key
    const key = item[keyName.toString()].toString();

    // If key was not added yet
    if (!result[key]) {
      // Add it now
      result[key] = item;
    }
  }

  // Done
  return result;
};
